console.log('single tsdirectory');

function initGallery(items, index = 0) {
    let pswpElement = document.querySelectorAll('.pswp')[0];

    let options = {
        // optionName: 'option value'
        // for example:
        index: index // start at first slide
    };

    // Initializes and opens PhotoSwipe
    let gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
}

(function($) {

    $(document).ready(function() {

        $('[data-toggle="gallery"]').on('click', function(e) {
            e.preventDefault();
            let index = $(this).data('index');
            initGallery(document.tsdGalleryItems, index);
        });
    });

})(jQuery);